import { render, staticRenderFns } from "./areaMap.vue?vue&type=template&id=20b60188&scoped=true"
import script from "./areaMap.vue?vue&type=script&lang=js"
export * from "./areaMap.vue?vue&type=script&lang=js"
import style0 from "./areaMap.vue?vue&type=style&index=0&id=20b60188&prod&scoped=true&lang=css"
import style1 from "./areaMap.vue?vue&type=style&index=1&id=20b60188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b60188",
  null
  
)

export default component.exports